import React from "react";

import productService from "../services/productService";

import { showProcess, hideProcess, UserSession } from "../utils/util";
import { Galleria } from "primereact/galleria";
import Banner001 from "../img/Banner001.png";

import { useParams } from "react-router-dom";
import { InputNumber } from "primereact/inputnumber";
import shoppingCartService from "../services/shoppingCartService";
import { Ripple } from "primereact/ripple";
import { RadioButton } from "primereact/radiobutton";
import { Checkbox } from "primereact/checkbox";
import { Dialog } from "primereact/dialog";
import { QRCodeCanvas } from "qrcode.react";
import saleOrderService from "../services/saleOrderService";
import accountService from "../services/accountService";
import { InputOtp } from "primereact/inputotp";
import userService from "../services/userService";

export default class Payment extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};
    }

    async componentDidMount() {
        try {
            await showProcess();

            if (UserSession !== null && UserSession !== undefined) {
                var shoppingCart = await this.getShoppingCart();

                if (shoppingCart === null || shoppingCart === undefined || shoppingCart === "") {
                    window.location.href = "/";
                    return;
                }

                var paymentMethods = await this.getPaymentMethods();

                this.setState({
                    shoppingCart: shoppingCart,
                    paymentMethods: [{ type: "ENTERATIVE" }, ...paymentMethods],
                });

                const response = await accountService.getBalance();

                if (response.status === 200) {
                    await localStorage.setItem("balance", JSON.stringify(response.data));
                }
            } else {
                window.location.href = "/";
            }

            window.addEventListener("resize", this.handleResize);
        } catch (err) {
            if (err.response) {
                console.log("status", err.response.status);
                console.log("headers", err.response.headers);
                console.log("data", err.response.data); // <- aqui normalmente vem a dica do que faltou
            } else {
                console.log("message", err.message);
            }
        }

        hideProcess();
    }

    handleResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    getShoppingCart = async () => {
        const response = await shoppingCartService.getShoppingCart();

        if (response.status === 200) {
            return response.data;
        }
    };

    getPaymentMethods = async () => {
        const response = await shoppingCartService.getPaymentMethods();

        if (response.status === 200) {
            return response.data;
        }
    };

    conclude = async () => {

        if (this.state.paymentMethod === undefined || this.state.paymentMethod === null) {
            alert("Selecione uma forma de pagamento!");
            return;
        }

        if (!this.state.acceptTerms) {
            alert("Necessário aceitar os termos de uso!");
            return;
        }

        try {
            showProcess();

            if (this.state.paymentMethod.type === "ENTERATIVE") {

                const response = await accountService.getBalance();

                await localStorage.setItem("balance", JSON.stringify(response.data));

                var balance = 0;

                if (!(response.data === undefined || response.data === null || response.data === "")){
                    balance = response.data;
                }

                var total = this.state.shoppingCart ? this.state.shoppingCart.lines.reduce((a, b) => a + b.amount, 0) :
                                                      this.state.saleOrder.lines.reduce((a, b) => a + b.amount, 0);

                if (balance < total) {
                    alert("Saldo insuficiente para concluir a compra. Por favor, escolha outra forma de pagamento ou recarregue seu saldo.");
                    hideProcess();
                    return;
                }
            }

            await userService.generateToken(localStorage.getItem("authorization"));

            this.setState({ token: undefined, showToken: true });
        } catch (ex) {
            if (ex.response !== undefined) {
                alert(ex.response.data);
            } else {
                alert(ex);
            }
        }

        hideProcess();
    };

    confirmToken = async (e) => {
        e.preventDefault();

        if (this.state.paymentMethod === undefined || this.state.paymentMethod === null) {
            alert("Selecione uma forma de pagamento!");
            return;
        }

        if (!this.state.acceptTerms) {
            alert("Necessário aceitar os termos de uso!");
            return;
        }

        try {
            showProcess();

            var response = await shoppingCartService.pay(
                0,
                this.state.paymentMethod.type,
                this.state.token
            );

            if (response.status === 200) {
                if (this.state.paymentMethod.type === "PIX") {
                    this.setState({
                        qrCode: response.data.qrCode,
                        orderId: response.data.orderId,
                        showToken: false,
                        token: undefined,
                    });
                } else {
                    window.location.href = "/saleorder/conclude/" + response.data.orderId;
                }
            }
        } catch (ex) {
            if (ex.response !== undefined) {
                alert(ex.response.data);
            } else {
                alert(ex);
            }
        }

        hideProcess();
    };

    hideQrCode = () => {
        if (window.confirm("Deseja cancelar a transação?")) {
            this.setState({ qrCode: undefined, orderId: undefined });

            clearInterval(this.timer);
            clearInterval(this.timerCheckPix);
        }
    };

    startTime = async () => {
        this.setState({ timeLeft: 60 * 20 }); //20 minutos

        this.timer = setInterval(() => {
            if (this.state.timeLeft <= 0) {
                clearInterval(this.timer);
                clearInterval(this.timerCheckPix);
                this.setState({ qrCode: undefined, orderId: undefined });
                alert("QR Code vencido.");
            } else {
                this.setState({ timeLeft: this.state.timeLeft - 1 });
            }
        }, 1000);

        this.timerCheckPix = setInterval(async () => {
            var response = await saleOrderService.getById(this.state.orderId);

            if (response.status === 200) {
                if (
                    response.data.status === "PAID" ||
                    response.data.status === "ACTIVATED" ||
                    response.data.status === "PAYMENT_UNDER_ANALYSIS"
                ) {
                    window.location.href = "/saleorder/conclude/" + this.state.orderId;
                }
            }
        }, 5000);
    };

    formatTime(seconds) {
        const hrs = String(Math.floor(seconds / 3600)).padStart(2, "0");
        const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
        const secs = String(seconds % 60).padStart(2, "0");
        return `${hrs}:${mins}:${secs}`;
    }

    copyQrCode = async () => {
        try {
            if (this.state.qrCode) {
                // Usa a API Clipboard para copiar o texto
                await navigator.clipboard.writeText(this.state.qrCode);
                alert("QR Code copiado para a área de transferência!");
            } else {
                alert("Nenhum QR Code disponível para copiar.");
            }
        } catch (err) {
            console.error("Erro ao copiar para a área de transferência:", err);
            alert("Erro ao copiar o QR Code. Tente novamente.");
        }
    }

    render() {
        if (this.state.shoppingCart !== undefined)
            return (
                <>
                    <div style={{width: "100%", borderBottom: "1px solid #ccc", padding: "0px 0px 20px", marginBottom: "20px"}}>
                        <label style={{ fontSize: "25px", fontWeight: "bold", marginBottom: "20px", color: "#3D4655" }}>Complete seu pagamento</label>
                        <br />
                        <label style={{ color: "#3D4655" }}>(Todos os campos são obrigatórios, a menos que indicado de outra forma)</label>
                    </div>
                    <div
                        style={{
                            backgroundColor: "#ffffff",
                            padding: "0px 0px 20px", 
                            overflowX: "hidden",
                        }}
                    >

                    <div style={{width: "100%", 
                             height: "50px",
                             marginBottom: "20px",
                             position: "relative",
                             }}>
                        <div style={{backgroundColor: "var(--unnamed-color-411172)", 
                                    color: "#ffffff",
                                    width: "fit-content", 
                                    padding: "15px 20px",
                                    borderTopRightRadius: "25px",
                                    borderBottomRightRadius: "25px",
                                    fontWeight: "bold",
                                    position: "absolute",
                                    textAlign: "center",
                                    left: "0px",
                                    width: "170px",
                                    borderRight: "8px solid #ffffff",
                                    zIndex: 1,
                                    fontSize: "14px",
                                    }}>
                            Carrinho
                        </div>
                        <div style={{backgroundColor: "var(--unnamed-color-411172)", 
                                        color: "#ffffff",
                                        width: "fit-content", 
                                        padding: "15px 20px",
                                        borderTopRightRadius: "25px",
                                        borderBottomRightRadius: "25px",
                                        fontWeight: "bold",
                                        position: "absolute",
                                        left: "155px",
                                        width: "170px",
                                        textAlign: "center",
                                        fontSize: "14px",
                                        }}>
                                Pagamento
                            </div>
                        </div>
                            

                            

                        {/* Conteúdo principal */}
                        <div
                            style={{
                                display: "flex",
                                flexDirection: this.state.windowWidth < 1024 ? "column" : "row",
                                alignItems: "stretch",
                                marginTop: "25px",
                                gap: this.state.windowWidth < 768 ? "20px" : "0",
                            }}
                        >
                            {/* Formas de pagamento */}
                            <div
                                style={{
                                    width: this.state.windowWidth < 1024 ? "100%" : "calc(100% - 420px)",
                                    backgroundColor: "#ffffff",
                                    border: "1px solid #707070",
                                    borderRadius: "20px",
                                    padding: "20px",
                                }}
                            >
                                <div
                                    style={{
                                        borderBottom: "1px solid #000141",
                                        color: "#411172",
                                        fontWeight: "700",
                                        fontSize: "18px",
                                        textAlign: "left",
                                        paddingBottom: "20px",
                                    }}
                                >
                                    Formas de pagamento
                                </div>

                                <div
                                    style={{
                                        marginTop: "20px",
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    {this.state.paymentMethods.map((p, i) => (
                                        <div
                                            key={i}
                                            className="flex align-items-center"
                                            style={{
                                                padding: "8px 0px",
                                                display: "flex",
                                                alignItems: "center",
                                            }}
                                        >
                                            <RadioButton
                                                inputId={"type" + p.type}
                                                value={p}
                                                onChange={(e) =>
                                                    this.setState({ paymentMethod: e.value })
                                                }
                                                checked={
                                                    this.state.paymentMethod !== undefined &&
                                                    this.state.paymentMethod.type === p.type
                                                }
                                            />
                                            <label htmlFor={"type" + p.type}>
                                                <img
                                                    src={require(
                                                        "../img/paymentMethods/" + p.type + ".png"
                                                    )}
                                                    style={{
                                                        height:
                                                            this.state.windowWidth < 768
                                                                ? "25px"
                                                                : "30px",
                                                        marginLeft: "15px",
                                                    }}
                                                />
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>

                            {/* Resumo do pedido */}
                            <div
                                style={{
                                    width: this.state.windowWidth < 1024 ? "100%" : "400px",
                                    padding: "20px",
                                    border: "1px solid #707070",
                                    borderRadius: "20px",
                                    marginLeft: this.state.windowWidth < 1024 ? "0" : "20px",
                                }}
                            >
                                <div
                                    style={{
                                        borderBottom: "1px solid #000141",
                                        color: "#411172",
                                        fontWeight: "700",
                                        fontSize: "18px",
                                        textAlign: "center",
                                        paddingBottom: "20px",
                                    }}
                                >
                                    Resumo Pedido
                                </div>

                                <table
                                    style={{
                                        width: "100%",
                                        marginTop: "30px",
                                        borderCollapse: "collapse",
                                    }}
                                >
                                    <tbody>
                                        <tr>
                                            <td
                                                style={{
                                                    textAlign: "left",
                                                    fontSize: "18px",
                                                    padding: "10px 0px",
                                                    borderBottom: "1px solid #3D4655",
                                                    color: "#3D4655",
                                                    fontWeight: "600",
                                                }}
                                            >
                                                Subtotal
                                            </td>
                                            <td
                                                style={{
                                                   textAlign: "right",
                                                    fontSize: "18px",
                                                    padding: "10px 0px",
                                                    borderBottom: "1px solid #3D4655",
                                                    color: "#3D4655",
                                                    fontWeight: "600",
                                                }}
                                            >
                                                R$
                                                {this.state.shoppingCart.lines
                                                    .reduce((a, b) => a + b.totalAmount, 0)
                                                    .toLocaleString("pt-BR", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })}
                                            </td>
                                        </tr>

                                        <tr>
                                            <td
                                                style={{
                                                    textAlign: "left",
                                                    fontSize: "18px",
                                                    padding: "10px 0px",
                                                    color: "#3D4655",
                                                    fontWeight: "600",
                                                }}
                                            >
                                                Total
                                            </td>
                                            <td
                                                style={{
                                                    textAlign: "right",
                                                    fontSize: "18px",
                                                    padding: "10px 0px",
                                                    color: "#3D4655",
                                                    fontWeight: "600",
                                                }}
                                            >
                                                R$
                                                {this.state.shoppingCart.lines
                                                    .reduce((a, b) => a + b.totalAmount, 0)
                                                    .toLocaleString("pt-BR", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        marginTop: "30px",
                                    }}
                                >
                                    <a
                                        href="/cart"
                                        style={{
                                            color: "#411172",
                                            fontSize: this.state.windowWidth < 768 ? "16px" : "18px",
                                            textAlign: "center",
                                            width: "80%",
                                            cursor: "pointer",
                                            fontWeight: "600",
                                            textDecoration: "underline",
                                        }}
                                    >
                                        Editar Carrinho
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* Aceite dos termos */}
                        <div
                            style={{
                                padding: this.state.windowWidth < 768 ? "20px 10px" : "30px",
                                textAlign: this.state.windowWidth < 768 ? "center" : "left",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    flexDirection: this.state.windowWidth < 768 ? "column" : "row",
                                    alignItems: "center",
                                    justifyContent:
                                        this.state.windowWidth < 768 ? "center" : "flex-start",
                                }}
                            >
                                <Checkbox
                                    id="chkTerms"
                                    onChange={(e) => this.setState({ acceptTerms: e.checked })}
                                    checked={this.state.acceptTerms}
                                />
                                <label
                                    htmlFor="chkTerms"
                                    style={{
                                        color: "#A3A3A3",
                                        fontSize: "18px",
                                        fontFamily: "var(--unnamed-font-family-work-sans)",
                                        marginLeft: this.state.windowWidth < 768 ? "10px" : "15px",
                                    }}
                                >
                                    Aceito os termos de uso.
                                </label>
                            </div>

                            <a
                                style={{
                                    color: "#88B6D8",
                                    textDecoration: "underline",
                                    cursor: "pointer",
                                    display: "block",
                                    marginTop: "10px",
                                }}
                            >
                                Ver Termos e Política de uso.
                            </a>

                            <button
                                style={{
                                    backgroundColor: "#411172",
                                    borderRadius: "12px",
                                    color: "#ffffff",
                                    padding: "15px",
                                    fontSize: "18px",
                                    textAlign: "center",
                                    cursor: "pointer",
                                    marginTop: "25px",
                                    width: this.state.windowWidth < 768 ? "100%" : "auto",
                                    fontWeight: "600",
                                }}
                                onClick={() => this.conclude()}
                            >
                                Pedido Concluído
                            </button>
                        </div>
                    </div>

                    {this.state.qrCode && (
                        <Dialog
                            visible={true}
                            onHide={() => this.hideQrCode()}
                            style={{ maxWidth: "300px" }}
                            onShow={() => this.startTime()}
                        >
                            <div style={{ textAlign: "center" }}>
                                <span
                                    style={{
                                        fontSize: "22px",
                                        color: "var(--unnamed-color-411172)",
                                    }}
                                >
                                    Efetue o pagamento do QR Code e aguarde que será redirecionado
                                    após a confirmação.
                                </span>
                                <br />
                                <QRCodeCanvas
                                    value={this.state.qrCode} // link ou texto
                                    size={200} // tamanho em pixels
                                    bgColor="#ffffff" // cor de fundo
                                    fgColor="#000000" // cor do QR
                                    level="H" // nível de correção de erro (L, M, Q, H)
                                    includeMargin={true} // adiciona margem
                                />
                                <br />

                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <input value={this.state.qrCode} style={{ width: "250px", padding: "8px", marginRight: "5px" }} readOnly />
                                    <span className="pi pi-copy" style={{ fontSize: "24px", cursor: "pointer" }} onClick={() => this.copyQrCode()} />
                                </div>

                                <br />
                                <label>{this.formatTime(this.state.timeLeft)}</label>
                            </div>
                        </Dialog>
                    )}

                    {this.state.showToken && (
                        <Dialog
                            visible={true}
                            onHide={() => this.setState({ showToken: false })}
                            onShow={() => {
                                setTimeout(() => {
                                    const otpInput = document.querySelector(".p-inputotp input");
                                    if (otpInput) otpInput.focus();
                                }, 0);
                            }}
                        >
                            <form
                                onSubmit={(e) => this.confirmToken(e)}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: "column",
                                }}
                            >
                                <div style={{ textAlign: "center" }}>
                                    <label>
                                        Enviamos um código de confirmação seu telefone.
                                        <br />
                                        Por favor informe-o.
                                    </label>
                                </div>
                                <div style={{ marginTop: "25px" }}>
                                    <InputOtp
                                        value={this.state.token}
                                        length={6}
                                        onChange={(e) => this.setState({ token: e.value })}
                                    />
                                </div>
                                <div
                                    style={{
                                        width: "100%",
                                        textAlign: "center",
                                        marginTop: "25px",
                                    }}
                                >
                                    <button
                                        style={{
                                            width: this.state.windowWidth < 768 ? "100%" : "80%",
                                            padding: "15px",
                                            fontSize: this.state.windowWidth < 768 ? "18px" : "20px",
                                            color: "var(--app-color-ffffff)",
                                            backgroundColor: "var(--app-color-primary)",
                                            borderRadius: "30px",
                                        }}
                                        type="submit"
                                    >
                                        Confirmar
                                    </button>
                                </div>
                            </form>
                        </Dialog>
                    )}
                </>
            );
    }
}
